// extracted by mini-css-extract-plugin
export var calendarView = "_5g-0";